import { AxiosRequestConfig, AxiosResponse } from 'axios'
import createHttp from '@/utils/axiosHttp'
import { isResponse } from '@/types'
import NProgress from 'nprogress'
import { message } from 'ant-design-vue'
import xss from 'xss'

const http = createHttp({
  timeout: 10000,
  baseURL: '/api', // api
  withCredentials: true,
  xsrfCookieName: 'Authorization',
  xsrfHeaderName: 'Authorization'
})

// XSS 清理函数
const sanitizeData = (data) => {
  if (typeof data === 'object' && data !== null) {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        if (typeof data[key] === 'string') {
          data[key] = xss(data[key])
        } else if (typeof data[key] === 'object') {
          data[key] = sanitizeData(data[key])
        }
      }
    }
  }
  return data
}

// 请求拦截器
http.interceptors.request.use(
  (config) => {
    if (!http.checkAuthorization() && config.url !== '/admin/login') {
      return
    }
    // 清理 GET 请求参数
    if (config.method === 'get' && config.params) {
      config.params = sanitizeData(config.params)
    }

    // 清理 POST 请求数据
    if (config.method === 'post' && config.data) {
      if (config.headers['Content-Type'] === 'multipart/form-data') {
        // 处理 formData 格式
        for (let pair of config.data.entries()) {
          if (typeof pair[1] === 'string') {
            config.data.set(pair[0], xss(pair[1]))
          }
        }
      } else {
        // 处理其他格式
        config.data = sanitizeData(config.data)
      }
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// http.interceptors.request.use( config => {
//   config.headers['Authorization'] = 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsImNyZWF0ZWQiOjE3MTkxMjQ0NDc4MjAsImV4cCI6MTcxOTcyOTI0N30.UlIIqm-amYIe-q6Ayz-d3Q_LK-hWDcYQjqrkiTEWUlpaqLz46_4JKdKLbovEYCPXUkv3gRhibHKrX8GPnKEJsQ'
//   return config
// })

const isAxiosResponse = (obj: any): obj is AxiosResponse => {
  return typeof obj === 'object' && obj.status && obj.statusText && obj.headers && obj.config
}

// progress 进度条 -- 开启
http.interceptors.request.use((req: AxiosRequestConfig) => {
  if (!NProgress.isStarted()) {
    NProgress.start()
  }
  return req
})

// 解析响应结果
http.interceptors.response.use(
  (rep: AxiosResponse<String>) => {
    const { data } = rep
    if (isResponse(data)) {
      if (data.code !== 200) {
        message.error(data.message)
      }
      return data.code === 200 ? data : Promise.reject(data)
    }
    return Promise.reject({ message: rep.statusText, code: rep.status, data })
  },
  (error) => {
    if (error.response && isAxiosResponse(error.response)) {
      return Promise.reject({
        message: error.response.statusText,
        code: error.response.status,
        data: error.response.data
      })
    }
    return Promise.reject(error)
  }
)

// progress 进度条 -- 关闭
http.interceptors.response.use(
  (rep) => {
    if (NProgress.isStarted()) {
      NProgress.done()
    }
    return rep
  },
  (error) => {
    if (NProgress.isStarted()) {
      NProgress.done()
    }
    return error
  }
)

export default http
